/**
 * НАЗНАЧЕНИЕ: Конфигурация Axios инстансов для API запросов
 * ОПИСАНИЕ: Создает настроенные экземпляры Axios для различных целей:
 * - baseApiInstance - основной API с автообновлением JWT токенов
 * - baseApiInstanceWithoutToken - для запросов без токенов (логин)
 * - dgxApiInstance - для внешнего ИИ-сервиса обработки слайдов
 * БЕЗОПАСНОСТЬ: Автоматическое обновление токенов через interceptors
 * CORS: Настройка credentials для cross-origin запросов
 * ДОМЕНЫ: pato.fcpriirf.ru (основной), patob.fcpriirf.ru (ИИ-сервис)
 */
import axios from "axios";
import {refreshAccessToken} from "shared/model/auth";

const urls = {
  baseURL: `https://pato.fcpriirf.ru/`
};

const dgxUrls = {
    dgxURL: `https://patob.fcpriirf.ru/`
};

const baseApiInstanceWithoutToken = axios.create(urls);
const baseApiInstance = axios.create(urls);
const dgxApiInstance = axios.create(dgxUrls);

baseApiInstance.interceptors.request.use(
    function (config) {
        const accessToken =
            JSON.parse(localStorage.getItem("app")).auth.accessToken || "";

        config.headers.Authorization = `Bearer ${accessToken}`;
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

const baseApiInstanceWithRefresh = axios.create(urls);

baseApiInstanceWithRefresh.interceptors.request.use(
    function (config) {
        const accessToken =
            JSON.parse(localStorage.getItem("app")).auth.accessToken || "";

        config.headers.Authorization = `Bearer ${accessToken}`;
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

baseApiInstanceWithRefresh.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    function (error) {
        const originalRequest = error.config;
        const {
            response: {status},
        } = error;
        if (status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            refreshAccessToken();
            return baseApiInstanceWithRefresh(originalRequest);
        }
        return Promise.reject(error);
    }
);

export {
    baseApiInstance,
    baseApiInstanceWithoutToken,
    baseApiInstanceWithRefresh,
    dgxApiInstance
};
